import { render, staticRenderFns } from "./LoadingFlag.vue?vue&type=template&id=62b855ec&scoped=true&"
import script from "./LoadingFlag.vue?vue&type=script&lang=js&"
export * from "./LoadingFlag.vue?vue&type=script&lang=js&"
import style0 from "./LoadingFlag.vue?vue&type=style&index=0&id=62b855ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b855ec",
  null
  
)

export default component.exports